var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pack-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC3E7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E286D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100,0 C168.429045,0 200,39.2500126 200,100 C200,160.749987 170.303194,200 100,200 C29.6968058,200 0,163.066536 0,100 C0,36.9334635 31.5709552,0 100,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.8676735%",
    y1: "11.9307278%",
    x2: "71.4586125%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE8FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9BAE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.9805992%",
    y1: "15.1651008%",
    x2: "94.3808906%",
    y2: "121.150643%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-539.000000, -2374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pack-4",
    transform: "translate(539.000000, 2374.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    transform: "translate(100.000000, 100.000000) scale(1, -1) translate(-100.000000, -100.000000) ",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "help",
    mask: "url(#mask-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,54.140625 C80,44.2132569 74.3048095,35.3533936 65.7751466,31.0437013 C65.5102539,50.078125 50.078125,65.5102539 31.0437013,65.7751466 C35.3533936,74.3048095 44.2132569,80 54.140625,80 C58.7951659,80 63.3215331,78.7603759 67.2985841,76.4050294 L79.887085,79.887085 L76.4050294,67.2985841 C78.7603759,63.3215331 80,58.7951659 80,54.140625 L80,54.140625 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.09375,30.546875 C61.09375,13.703003 47.390747,0 30.546875,0 C13.703003,0 0,13.703003 0,30.546875 C0,36.0363769 1.46118156,41.3812256 4.23583984,46.0736084 L0.112304688,60.980835 L15.0201416,56.8579102 C19.7125244,59.6325684 25.0573731,61.09375 30.546875,61.09375 C47.390747,61.09375 61.09375,47.390747 61.09375,30.546875 Z M25.859375,23.4375 L21.171875,23.4375 C21.171875,18.2678222 25.3771972,14.0625 30.546875,14.0625 C35.7165528,14.0625 39.921875,18.2678222 39.921875,23.4375 C39.921875,26.0614014 38.8110352,28.5833741 36.8731689,30.355835 L32.890625,34.0008545 L32.890625,37.65625 L28.203125,37.65625 L28.203125,31.9366455 L33.7084961,26.897583 C34.6923828,25.9973144 35.234375,24.7686767 35.234375,23.4375 C35.234375,20.8526611 33.1317139,18.75 30.546875,18.75 C27.9620361,18.75 25.859375,20.8526611 25.859375,23.4375 Z M28.203125,42.34375 L32.890625,42.34375 L32.890625,47.03125 L28.203125,47.03125 L28.203125,42.34375 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack4);
export default __webpack_public_path__ + "static/media/pack-4.d1cadfc4203d230634fd6686de036340.svg";
export { ForwardRef as ReactComponent };